import React from 'react';
import styled from 'styled-components';
import IconLocalShipping from '@tvg/fuse-icons/lib/LocalShipping';
import { Modal } from '@tvg/fuse-design';
import { DeliveryAndReturnsDialogProps } from '../DeliveryAndReturnsProps';

const Body = styled.div`
  color: var(--color-font-paragraph);
  font-weight: var(--font-weight-paragraph);
  font-size: var(--font-size-1);
  line-height: var(--font-line-height-1);

  h3,
  h4,
  h5 {
    color: var(--color-font-heading);
  }

  h3 {
    font-size: var(--font-size-3);
    line-height: var(--font-line-height-3);
    margin-bottom: var(--spacing-space16);
  }

  h4,
  h5 {
    font-size: var(--font-size-1);
    line-height: var(--font-line-height-1);
    margin-bottom: var(--spacing-space16);
  }

  h5 {
    margin-bottom: var(--spacing-space8);
  }

  p {
    margin-bottom: var(--spacing-space16);
  }

  ul {
    list-style: disc;
    padding-left: var(--spacing-space16);
    margin-bottom: var(--spacing-space16);
  }

  li:not(:last-child) {
    margin-bottom: var(--spacing-space4);
  }

  dl {
    display: grid;
    grid-template-columns: 50% 50%;
    border-bottom: 1px solid var(--color-greys-grey3);
    margin-bottom: var(--spacing-space16);

    > * {
      margin: 0;
      padding: var(--spacing-space16);
    }

    dt:nth-child(4n + 1),
    dd:nth-child(4n + 2) {
      background-color: var(--color-greys-grey3);
    }
  }

  a {
    text-decoration: underline;
    cursor: pointer;

    color: var(--color-font-paragraph);
    font-weight: var(--font-weight-paragraph);
    font-size: var(--font-size-1);
    line-height: var(--font-line-height-1);

    &:hover {
      color: var(--color-brand-mid) !important;
    }

    &:visited {
      color: var(--color-font-paragraph);
    }
  }

  > *:last-child {
    margin-bottom: 0;
  }
`;

const BrandLogo = styled.img`
  margin-bottom: var(--spacing-space16);
`;

function DeliveryAndReturnsDialog(props: DeliveryAndReturnsDialogProps) {
  const { body, brand, brandLogoUrl, heading, onClose, open } = props;

  return (
    <Modal
      dataTestId="delivery-and-returns-dialog"
      headerIcon={<IconLocalShipping />}
      name="delivery-and-returns-dialog"
      onClose={onClose}
      open={open}
      srLabelCloseButton="Close delivery and returns dialog"
      title={heading}
      zIndex="20"
    >
      {brand && brandLogoUrl && (
        <BrandLogo
          src={brandLogoUrl}
          width="120"
          alt={`${brand} brand logo`}
          data-testid="delivery-and-returns-brand-logo"
        />
      )}
      <Body data-testid="delivery-and-returns-dialog-body" dangerouslySetInnerHTML={{ __html: body }} />
    </Modal>
  );
}

export default DeliveryAndReturnsDialog;
